import { render } from "./AlsoLike.vue?vue&type=template&id=12c74dc9&scoped=true"
import script from "./AlsoLike.vue?vue&type=script&lang=js"
export * from "./AlsoLike.vue?vue&type=script&lang=js"

import "./AlsoLike.vue?vue&type=style&index=0&id=12c74dc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c74dc9"]])

export default __exports__